<template>
  <div class="applicationListField">
    <div class="check">
      <input type="checkbox" />
    </div>
    <div class="right">
      <img :src="itemData.icon" alt="" />
      <div class="name">{{ itemData.name }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ApplicationListField",
  components: {},
  props: {
    itemData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  async mounted() {},
  methods: {},
};
</script>

<style scoped lang="scss">
.applicationListField {
  display: flex;
  align-items: center;
  background: #fff;
  border-radius: 8px;
  height: 64px;
  margin-top: 14px;
  padding: 0px 15px;
  .right{
    display: flex;
    align-items: center;
    img {
      width: 34px;
      height: 34px;
      margin-right: 8px;
    }
  }
}
input[type="checkbox"] {
  appearance: none;
  -webkit-appearance: none;
  width: 16px;
  height: 16px;
  border: 1px solid #01a0e5;
  border-radius: 50%;
  margin-right: 8px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  flex-shrink: 0;

  &:checked {
    background-color: #01a0e5;
    &::after {
      content: "";
      width: 8px;
      height: 4px;
      border: 2px solid #fff;
      border-top: none;
      border-right: none;
      transform: rotate(-45deg);
      margin-top: -2px;
    }
  }
}
</style>
